import apiClient from './meta-client';
import type {
    Employee,
    CollaboratorAccessRecord,
    CollaboratorAccessUpdate,
} from '@/pages/Meta/Connection/types/meta.types';

// ====================================
// Colaboradores — wrapper sobre /api/v1/collaborators do ms-meta-api.
// O ms-meta-api faz proxy pro apisistema /employees, então a lista de
// colaboradores vem de lá. Os acessos são salvos localmente em
// chatmeta_collaborator_access.
// ====================================

export const listEmployees = async (): Promise<Employee[]> => {
    const r = await apiClient.get<Employee[]>('/collaborators');
    return r.data;
};

export const getCollaboratorAccess = async (
    collaboratorId: number,
): Promise<CollaboratorAccessRecord[]> => {
    const r = await apiClient.get<CollaboratorAccessRecord[]>(
        `/collaborators/${collaboratorId}/access`,
    );
    return r.data;
};

export const setCollaboratorAccess = async (
    collaboratorId: number,
    accesses: CollaboratorAccessUpdate[],
): Promise<{ message: string; saved: number }> => {
    const r = await apiClient.put(`/collaborators/${collaboratorId}/access`, { accesses });
    return r.data;
};

export const deleteCollaboratorAccess = async (
    accessId: number,
): Promise<{ message: string; success: boolean }> => {
    const r = await apiClient.delete(`/collaborators/access/${accessId}`);
    return r.data;
};
